import { render } from "./App.vue?vue&type=template&id=54ff5aff"
const script = {}

import "./App.vue?vue&type=style&index=0&id=54ff5aff&lang=css"
script.render = render

export default script